import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon';
import type { IconName } from '../icon/icon';

export type StatTone = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-stat-card',
  imports: [IconComponent],
  styleUrl: './stat-card.scss',
  templateUrl: './stat-card.html',
})
export class StatCardComponent {
  /** Libellé de la statistique. */
  readonly label = input('');

  /** Valeur affichée (nombre ou texte). */
  readonly value = input<string | number>('');

  /** Icône décorative. */
  readonly icon = input<IconName>('dashboard');

  /** Teinte de l'icône. */
  readonly tone = input<StatTone>('primary');

  /** Description / tendance optionnelle. */
  readonly description = input('');
}
